import Box from '@mui/material/Box';
import type { JSONContent } from '@tiptap/core';

import { RichTextField } from '@/components/form/RichTextField';

import { State } from '../State';

/** A sample limit: a real screen reads it from its reply's `limits`. */
const SAMPLE_MAX_LENGTH = 2000;

const SAMPLE_DOCUMENT: JSONContent = {
  type: 'doc',
  content: [
    {
      type: 'heading',
      attrs: { level: 2 },
      content: [{ type: 'text', text: 'Why we organize' }],
    },
    {
      type: 'paragraph',
      content: [
        { type: 'text', text: 'Every voice counts, and ' },
        { type: 'text', text: 'every vote', marks: [{ type: 'bold' }] },
        { type: 'text', text: ' needs a voter.' },
      ],
    },
    {
      type: 'ctaButton',
      attrs: { label: 'Join us', href: 'https://example.org/join' },
    },
  ],
};

export function RichTextFieldExamples() {
  return (
    <>
      <State title="Empty">
        <Box sx={{ maxWidth: 640 }}>
          <RichTextField
            label="Introduction"
            hint="Headings, bold, italic, lists, links and buttons."
            value={null}
            onChange={() => undefined}
            maxLength={SAMPLE_MAX_LENGTH}
            testId="gallery-rich-text-field-empty"
          />
        </Box>
      </State>

      <State title="With content">
        <Box sx={{ maxWidth: 640 }}>
          <RichTextField
            label="Introduction"
            value={SAMPLE_DOCUMENT}
            onChange={() => undefined}
            maxLength={SAMPLE_MAX_LENGTH}
            testId="gallery-rich-text-field-filled"
          />
        </Box>
      </State>

      <State title="With an error" note="The server's sentence for a refused document.">
        <Box sx={{ maxWidth: 640 }}>
          <RichTextField
            label="Introduction"
            value={SAMPLE_DOCUMENT}
            onChange={() => undefined}
            error="Start the address with https://, mailto: or tel:"
            maxLength={SAMPLE_MAX_LENGTH}
            testId="gallery-rich-text-field-error"
          />
        </Box>
      </State>

      <State title="Disabled">
        <Box sx={{ maxWidth: 640 }}>
          <RichTextField
            label="Introduction"
            value={SAMPLE_DOCUMENT}
            onChange={() => undefined}
            disabled
            maxLength={SAMPLE_MAX_LENGTH}
            testId="gallery-rich-text-field-disabled"
          />
        </Box>
      </State>
    </>
  );
}
